/**
 * Escape all interpolated portions of the URI.
 */
export default function l (strings: TemplateStringsArray, ...values: Array<{}>) {
  return strings.reduce((acc, s, i) => {
    return acc + s + (i === values.length ? '' : encodeURIComponent(`${values[i]}`));
  }, '');
}



// WEBPACK FOOTER //
// ./src/l.ts